import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

import { ChevronDown } from '../../assets';
import { SelectOption } from '../../models/SelectOption';
import { Select } from '../index';

import './TitleSelect.scss';

interface Props {
  placeholder?: string;
  options: SelectOption[];
  value: string;
  isLoading: boolean;
  onChange: (value: string) => void;
}

const TitleSelect: FC<Props> = ({ options = [], placeholder, value, isLoading = false, onChange }) => {
  return (
    <div className='title-select'>
      {options.length > 1 && <Select options={options} onChange={onChange} value={value} placeholder={placeholder} />}
      <div className='select-dummy'>
        {isLoading ? (
          <Skeleton height={30} width={150} />
        ) : (
          <>
            <p>{options.find(option => option.value === value)?.label}</p>
            {options.length > 1 && <ChevronDown />}
          </>
        )}
      </div>
    </div>
  );
};

export default TitleSelect;
